// extracted by mini-css-extract-plugin
module.exports = {"select-wrapper":"style_select-wrapper__UM3Yg"};